import {useRef} from "react";
import {Canvas} from '@react-three/fiber';
import {OrbitControls, Html} from '@react-three/drei';
import * as THREE from 'three';


function Point({position, label, color}) {
    return (
        <>
            <mesh position={position}>
                <sphereGeometry args={[0.05, 16, 16]} />
                <meshStandardMaterial color={color} />
            </mesh>
            <Html
                position={position}
                style={{color: 'black', fontWeight: 'bold', whiteSpace: 'nowrap'}}
            >
                {label}
            </Html>
        </>
    );
}

function ArcOnSphere({start, end, radius, color, label}) {
    const startVec = new THREE.Vector3(...start).normalize();
    const endVec = new THREE.Vector3(...end).normalize();
    const angle = startVec.angleTo(endVec);
    const segments = 100;
    const points = [];

    for (let i = 0; i <= segments; i++) {
        const t = i / segments;
        const axis = new THREE.Vector3().crossVectors(startVec, endVec).normalize();
        const quaternion = new THREE.Quaternion().setFromAxisAngle(axis, angle * t);
        const point = startVec.clone().applyQuaternion(quaternion).multiplyScalar(radius);
        points.push(point);
    }

    const geometry = new THREE.BufferGeometry().setFromPoints(points);

    // Compute midpoint for label
    const midIndex = Math.floor(points.length / 2);
    const midPoint = points[midIndex];

    return (
        <>
            <line geometry={geometry}>
                <lineBasicMaterial color={color} linewidth={2} />
            </line>
            {
                label && <Html
                    position={midPoint.toArray()}
                    style={{
                        color: 'black',
                        fontWeight: 'bold',
                        whiteSpace: 'nowrap',
                        transform: 'translate(-50%, -50%)',
                    }}
                >
                    {label}
                </Html>
            }
        </>
    );
}

function SphereWithPointsAndArcs({
                                     points,
                                     naivePoints,
                                     radius,
                                     labels,
                                     naiveLabels,
                                     realDist,
                                     naiveDist,
}) {
    const basisPoints = [
        new THREE.Vector3(0, 0, 0), // O
        new THREE.Vector3(2, 0, 0), // X
        new THREE.Vector3(0, 2, 0), // Y
        new THREE.Vector3(0, 0, 2), // Z
    ];
    const basisLabels = ['O' ,'X', 'Y', 'Z'];

    return (
        <Canvas
            camera={{position: [3, 3, 3], up: [0, 0, 1], fov: 50}}
            style={{width: '95vw', height: '57vh'}}
        >
            <ambientLight intensity={0.5}/>
            <pointLight position={[5, 5, 5]}/>
            <mesh rotation={[Math.PI / 2, 0, 0]}>
                <sphereGeometry args={[radius, 32, 32]}/>
                <meshStandardMaterial color="#dddddd" wireframe opacity={0.6} transparent/>
            </mesh>
            {basisPoints.map((point, i) => (
                <Point key={i} position={point.toArray()} label={basisLabels[i]} color='blue'/>
            ))}
            {points.map((point, i) => (
                <Point key={i} position={point.toArray()} label={labels[i]} color='red'/>
            ))}
            {naivePoints.map((point, i) => (
                <Point key={i} position={point.toArray()} label={naiveLabels[i]} color='green'/>
            ))}
            <ArcOnSphere
                start={points[1].toArray()}
                end={points[0].toArray()}
                radius={radius}
                color='red'
            />
            <ArcOnSphere
                start={points[1].toArray()}
                end={points[2].toArray()}
                radius={radius}
                color='red'
                label={realDist}
            />

            <ArcOnSphere
                start={naivePoints[0].toArray()}
                end={points[0].toArray()}
                radius={radius}
                color='green'
            />
            <ArcOnSphere
                start={naivePoints[0].toArray()}
                end={naivePoints[1].toArray()}
                radius={radius}
                color='green'
                label={naiveDist}
            />

            <OrbitControls/>
        </Canvas>
    );
}



export default function ({dataToRender}) {
    console.log(dataToRender);

    const transformCooToCartesian = (r, phi, tetta) => {
        let radian_phi = +phi / 360 * 2 * Math.PI;
        let radian_tetta = (90 - +tetta) / 360 * 2 * Math.PI;
        return new THREE.Vector3(
            r * Math.sin(radian_tetta) * Math.cos(radian_phi),
            r * Math.sin(radian_phi) * Math.sin(radian_tetta),
            r * Math.cos(radian_tetta),
        );
    };

    const data = [
        {
            "first_city": "Москва",
            "first_real_lat": "55.7558",
            "first_real_lon": "37.6172",
            "first_naive_lat": "50",
            "first_naive_lon": "32",
            "second_city": "Екатеринбург",
            "second_real_lat": "56.8356",
            "second_real_lon": "60.6128",
            "second_naive_lat": "61",
            "second_naive_lon": "53",
            "real_angle": "75.6",
            "naive_angle": "62.4",
            "angle_diff": "13.3",
            "real_dist": "1417.2",
            "naive_dist": "1342.2",
        },
        {
            "first_city": "Москва",
            "first_real_lat": "55.7558",
            "first_real_lon": "37.6172",
            "first_naive_lat": "50",
            "first_naive_lon": "32",
            "second_city": "Пермь",
            "second_real_lat": "58.0000",
            "second_real_lon": "56.3167",
            "second_naive_lat": "51",
            "second_naive_lon": "50",
            "real_angle": "69.9",
            "naive_angle": "86.8",
            "angle_diff": "17.0",
            "real_dist": "1159.2",
            "naive_dist": "1020.7"
        },
        {
            "first_city": "Москва",
            "first_real_lat": "55.7558",
            "first_real_lon": "37.6172",
            "first_naive_lat": "50",
            "first_naive_lon": "32",
            "second_city": "Владивосток",
            "second_real_lat": "43.1333",
            "second_real_lon": "131.9000",
            "second_naive_lat": "50",
            "second_naive_lon": "150",
            "real_angle": "59.4",
            "naive_angle": "90.0",
            "angle_diff": "30.6",
            "real_dist": "6414.8",
            "naive_dist": "6680.9"
        },
        {
            "first_city": "Екатеринбург",
            "first_real_lat": "56.8356",
            "first_real_lon": "60.6128",
            "first_naive_lat": "61",
            "first_naive_lon": "53",
            "second_city": "Пермь",
            "second_real_lat": "58.0000",
            "second_real_lon": "56.3167",
            "second_naive_lat": "51",
            "second_naive_lon": "50",
            "real_angle": "298.5",
            "naive_angle": "196.7",
            "angle_diff": "101.8",
            "real_dist": "287.9",
            "naive_dist": "591.1"
        },
        {
            "first_city": "Екатеринбург",
            "first_real_lat": "56.8356",
            "first_real_lon": "60.6128",
            "first_naive_lat": "61",
            "first_naive_lon": "53",
            "second_city": "Владивосток",
            "second_real_lat": "43.1333",
            "second_real_lon": "131.9000",
            "second_naive_lat": "50",
            "second_naive_lon": "150",
            "real_angle": "75.6",
            "naive_angle": "96.5",
            "angle_diff": "20.9",
            "real_dist": "5063.9",
            "naive_dist": "5527.2"
        },
        {
            "first_city": "Пермь",
            "first_real_lat": "58.0000",
            "first_real_lon": "56.3167",
            "first_naive_lat": "51",
            "first_naive_lon": "50",
            "second_city": "Владивосток",
            "second_real_lat": "43.1333",
            "second_real_lon": "131.9000",
            "second_naive_lat": "50",
            "second_naive_lon": "150",
            "real_angle": "73.6",
            "naive_angle": "90.6",
            "angle_diff": "17.0",
            "real_dist": "5277.4",
            "naive_dist": "5662.1"
        }
    ];

    const radius = 1;

    const caseToDraw = data[2];

    let first_city = caseToDraw['first_city'];
    let first_real_lat = caseToDraw['first_real_lat'];
    let first_real_lon = caseToDraw['first_real_lon'];
    let second_city = caseToDraw['second_city'];
    let second_real_lat = caseToDraw['second_real_lat'];
    let second_real_lon = caseToDraw['second_real_lon'];
    let real_azimuth = caseToDraw['real_angle'];
    let naive_azimuth = caseToDraw['naive_angle'];
    let azimuth_diff = caseToDraw['angle_diff'];
    let real_dist = caseToDraw['real_dist'];
    let naive_dist = caseToDraw['naive_dist'];

    let first_real_point = transformCooToCartesian(radius, first_real_lon, first_real_lat);
    let second_real_point = transformCooToCartesian(radius, second_real_lon, second_real_lat)

    let equator_real_point = transformCooToCartesian(radius, "0", "0");

    const points = [
        new THREE.Vector3(0, 0, radius), // Nord point
        first_real_point,
        second_real_point,
        equator_real_point,
    ];
    const labels = ['N', first_city + ` (азимут: ${real_azimuth})`, second_city, 'Остров ноль'];

    let first_naive_lat = caseToDraw['first_naive_lat'];
    let first_naive_lon = caseToDraw['first_naive_lon'];
    let second_naive_lat = caseToDraw['second_naive_lat'];
    let second_naive_lon = caseToDraw['second_naive_lon'];

    let first_naive_point = transformCooToCartesian(radius, first_naive_lon, first_naive_lat);
    let second_naive_point = transformCooToCartesian(radius, second_naive_lon, second_naive_lat)

    const naivePoints = [first_naive_point, second_naive_point];
    const naiveLabels = [
        first_city + ` (азимут: ${naive_azimuth}, Δ с реальным: ${azimuth_diff})` + '`',
        second_city + '`'
    ];

    return <SphereWithPointsAndArcs
        points={points}
        naivePoints={naivePoints}
        naiveLabels={naiveLabels}
        radius={radius}
        labels={labels}
        realDist={"Расст.: " + Math.round(+real_dist)}
        naiveDist={
            "Расст.: "
            + Math.round(naive_dist)
            + ", Δ с реальным: "
            + Math.round(Math.abs(+real_dist - +naive_dist))
        }
    />
}
